import { route } from "preact-router";
import { STRINGS } from "../constants/strings";
import { toErrorPath } from "../routes";
import type { ErrorType } from "../types";

export function handleSubmitFailure(
  res: { status: string; message?: string },
  redirectStatuses: ErrorType[],
  setSubmitError: (message: string) => void
): void {
  if (res.status === "rate_limited") {
    setSubmitError(STRINGS.resendRateLimit);
    return;
  }
  const redirect = redirectStatuses.find((s) => s === res.status);
  if (redirect) {
    route(toErrorPath(redirect));
    return;
  }
  setSubmitError(res.message || STRINGS.genericError);
}
